import ReactCompareImage from 'react-compare-image';

const ImageComparison = ({ leftImage, rightImage, ...props }) => (
  <ReactCompareImage leftImage={leftImage} rightImage={rightImage} {...props} />
);

export default ImageComparison;
